<template>
	<div>
		<page-header>
			<template #title>
				
				<h4 span v-if="loading && !caseEntity.patient?.list_name">
					<font-awesome-icon icon="circle-notch" spin fixed-width />
				</h4>
				<span span v-if="loading && !caseEntity.patient?.date_of_birth">
				</span>
				<span span v-if="loading && !caseEntity.patient?.age">
				</span>
				

				<div v-else class="d-flex">
					<!-- <h4  class="mb-0"> 
						{{ caseEntity.patient?.list_name ?? "View Case" }}
					</h4> -->
					<h4> 
						<router-link :to="{ name: 'patients.view', params: { id: caseEntity.patient?.id || '' } }">
							{{ caseEntity.patient?.list_name ?? "View Case" }}
						</router-link>
					</h4>
					<h3 v-if="$filters.formatDate(caseEntity.patient.date_of_birth) == false" class="h6 mt-2 ml-1 text-warning">(Missing DOB)</h3> 
					<span v-if="$filters.formatDate(caseEntity.patient.date_of_birth)" class="mx-2">|</span> <!-- Separator between elements -->
					
					<span v-if="$filters.formatDate(caseEntity.patient.date_of_birth)" class="small-text">
						<!-- <font-awesome-icon icon="birthday-cake" /> -->
						<span>{{ $filters.formatDate(caseEntity.patient.date_of_birth) }}</span>
									<span v-if="caseEntity.patient.age">
										&mdash;
										{{ caseEntity.patient.age }}
									</span>
						<span v-if="caseEntity.patient.age !== 0" >yrs</span>
					</span>
				</div>
				<!-- <div style="font-size: 0.75rem; color: #6c757d; padding-top: 0.5rem;">
					<case-activity :case-id="$route.params.id" />
				</div> -->
				
				<b-button @click="showDetails = !showDetails" variant="secondary">
							<span v-if="showDetails">Hide Details</span>
							<span v-else>Case Details</span>
				</b-button>
				<!-- Case Notes Button -->
				<!-- <b-button  @click="toggleShowCaseNotes" class="btn-orange-gradient" >
					
					<span v-if="showCaseNotes">Case Notes</span>
					<span v-if="!showCaseNotes">Case Notes</span>
				</b-button> -->
				<b-button @click="toggleShowCaseNotes" :style="{ backgroundColor: '#FFC7ED', borderColor: '#000', color: '#000', borderWidth: '1px', borderStyle: 'solid' }">
					<span v-if="showCaseNotes">Case Notes</span>
					<span v-if="!showCaseNotes">Case Notes</span>
				</b-button>
				<!-- Old Notes Button -->
				<b-button v-if="caseEntity.old_notes !== null" @click="toggleOldNotes" class="btn-orange-gradient">
					<span v-if="showOldNotes">Old Notes</span>
					<span v-else>Old Notes</span>
				</b-button>
				<div class="mt-1">
					<span class="h6"> <strong>Facility Name: </strong>{{ caseEntity.facility.name }}</span>
				</div>
                 <!-- <h4 v-else> 
	                {{ caseEntity.patient?.list_name ?? "View Case" }}
                 </h4>
					
				<span v-if="$filters.formatDate(caseEntity.patient.date_of_birth )" class="small-text">
					
					<font-awesome-icon icon="birthday-cake" />
					{{ $filters.formatDate(caseEntity.patient.date_of_birth ) }}
					&mdash;
					{{ caseEntity.patient?.age+' yrs' ?? "View Case" }}
				</span> -->
			</template>
			<template #buttons>
				<!-- <b-button
					variant="light"
					v-if="!caseClosed"
					v-b-modal.closeCaseModal
					:disabled="showLoading"
					title="Close this case when all opportunities have concluded"
					class="btn btn-outline-primary"
				> -->
				<b-button
					variant="light"
					v-if="!caseClosed"
					@click="checkAndOpenModal"
					:disabled="showLoading"
					title="Close this case when all opportunities have concluded"
					class="btn btn-outline-primary"
				>
					<font-awesome-icon icon="lock" fixed-width />
					<span>Close Case</span>
				</b-button>
				<b-button
					variant="ligth"
					v-else
					@click="reopenCase"
					:disabled="showLoading || reopening"
					title="Reopen this case for further progression"
					class="btn btn-outline-primary"
				>
					<font-awesome-icon v-if="reopening" icon="sync" :spin="reopening" fixed-width />
					<font-awesome-icon v-else icon="unlock" fixed-width />
					<span>Reopen Case</span>
				</b-button>

				<b-dropdown variant="secondary" right title="More Options">
					<template #button-content>
						<font-awesome-icon icon="cog" :spin="loading" fixed-width />
					</template>
					

					<b-dropdown-item
						:to="{ name: 'cases.edit', params: { id: $route.params.id } }"
						title="Edit case details"
						:disabled="isCaseClosed"
					>
						<font-awesome-icon icon="edit" fixed-width />
						<span>Edit Case</span>
					</b-dropdown-item>



					<b-dropdown-item @click="refresh" :disabled="loading" title="Refresh case details">
						<font-awesome-icon icon="sync" :spin="loading" fixed-width />
						<span>Refresh</span>
					</b-dropdown-item>

					<b-dropdown-item @click="caseStatsModalViewControl" :disabled="loading" title="View Case Stats">
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<div>View Case Stats</div>
							</div>
							<font-awesome-icon icon="chevron-right" class="my-0 py-0" />
						</div>
					</b-dropdown-item>

					<b-dropdown-divider />

					<b-dropdown-item
						v-if="caseEntity.patient && caseEntity.patient.id"
						:to="{
							name: 'patients.view',
							params: { id: caseEntity.patient.id },
						}"
						title="View patient details"
					>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<div>View Patient</div>
								<small class="text-muted d-block">
									{{ $filters.truncatedString(caseEntity.patient.full_name, 20) }}
								</small>
							</div>
							<font-awesome-icon icon="chevron-right" class="my-0 py-0" />
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						v-if="caseEntity.patient && caseEntity.patient.id"
						:to="{
							name: 'patients.edit',
							params: { id: caseEntity.patient.id },
						}"
						title="Edit patient details"
					>
						<font-awesome-icon icon="edit" fixed-width />
						<span>Edit Patient</span>
					</b-dropdown-item>

					<b-dropdown-divider />

					<b-dropdown-item
						v-if="caseEntity.facility && caseEntity.facility.id"
						:to="{
							name: 'facilities.view',
							params: { id: caseEntity.facility.id },
						}"
						title="View facility details"
					>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<div>View Facility</div>
								<small class="text-muted d-block">
									{{ $filters.truncatedString(caseEntity.facility.name, 20) }}
								</small>
							</div>
							<font-awesome-icon icon="chevron-right" class="my-0 py-0" />
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						v-if="caseEntity.insurance_provider && caseEntity.insurance_provider.id"
						:to="{
							name: 'insuranceProviders.view',
							params: { id: caseEntity.insurance_provider.id },
						}"
						title="View insurance provider details"
					>
						<div class="d-flex justify-content-between align-items-center">
							<div class="mr-3">
								<div>View Insurance Provider</div>
								<small class="text-muted d-block">
									{{ $filters.truncatedString(caseEntity.insurance_provider.name, 20) }}
								</small>
							</div>
							<font-awesome-icon icon="chevron-right" class="my-0 py-0" />
						</div>
					</b-dropdown-item>

					<b-dropdown-divider />

					<b-dropdown-item
						@click="deleteEntity"
						:disabled="showLoading"
						variant="danger"
						title="Delete this case"
					>
						<font-awesome-icon icon="trash" fixed-width />
						<span>Delete Case</span>
					</b-dropdown-item>
				</b-dropdown>
				<case-activity :case-id="$route.params.id" />
				<span v-if="caseEntity.modified" :title="$filters.formatTimestamp(caseEntity.modified)">
                	Last updated {{ $filters.fromNow(caseEntity.modified) }}
            	</span>
				<span v-if="caseEntity.modified_by_user && caseEntity.modified_by_user.full_name">
					by
					<router-link
						:to="{ name: 'users.view', params: { id: caseEntity.modified_by } }"
						title="View User"
					>
						{{ caseEntity.modified_by_user.full_name }}
					</router-link>
				</span>
				<!-- <case-assign :case-entity="caseEntity" @assigned="refreshAllComponents" class="ml-auto w-50 mt-1" />          -->
				<case-assign 
					:case-entity="caseEntity" 
					@assigned="refreshAllComponents" 
					class="ml-auto mt-1" 
					style="width: 100%;"
				/>



	<!-- 			<b-row> 
    <b-col cols="12" md="6" class="text-left mb-2">
        <div v-if="caseEntity.modified" class="small text-muted">
            <span v-if="caseEntity.modified" :title="$filters.formatTimestamp(caseEntity.modified)">
                Last updated {{ $filters.fromNow(caseEntity.modified) }}
            </span>
            <span v-if="caseEntity.modified_by_user && caseEntity.modified_by_user.full_name">
                by
                <router-link
                    :to="{ name: 'users.view', params: { id: caseEntity.modified_by } }"
                    title="View User"
                >
                    {{ caseEntity.modified_by_user.full_name }}
                </router-link>
            </span>
        </div>
    </b-col>
</b-row> -->

				 <!-- <div style="font-size: 0.75rem; color: #6c757d; ">
					<case-activity :case-id="$route.params.id" />
				</div>
				<div v-if="caseEntity.modified" class="d-flex align-items-center small text-muted justify-content-end">
					<span v-if="caseEntity.modified" :title="$filters.formatTimestamp(caseEntity.modified)">
						Last updated {{ $filters.fromNow(caseEntity.modified) }}
					</span>
					<span v-if="caseEntity.modified_by_user && caseEntity.modified_by_user.full_name" class="ml-1">
						by
						<router-link
							:to="{ name: 'users.view', params: { id: caseEntity.modified_by } }"
							title="View User"
						>
							{{ caseEntity.modified_by_user.full_name }}
						</router-link>
					</span>
				</div>	
				<case-assign :case-entity="caseEntity" @assigned="refreshAllComponents" class="ml-auto w-50 mt-1" /> -->
						
			</template>
		</page-header>

		<loading-indicator v-if="showLoading" class="my-5" />
		<b-container v-else-if="error" fluid>
			<error-alert class="my-5">
				<span>{{ error }}</span>
				<template #content>
					<div class="my-4">
						<b-button variant="primary" :to="{ name: 'cases' }">
							<font-awesome-icon icon="list" fixed-width />
							<span>All Cases</span>
						</b-button>

						<b-button variant="secondary" @click="refresh" :disabled="loading">
							<font-awesome-icon icon="sync" :spin="loading" fixed-width />
							<span>Retry</span>
						</b-button>
					</div>
				</template>
			</error-alert>
		</b-container>
		
		<b-card v-else no-body>
			<b-card-header header-tag="nav">
				<!-- <b-row>
					<b-col cols="12" md="6" class="mb-2">
						<case-activity :case-id="$route.params.id" />
					</b-col>
					<b-col cols="12" md="6" class="text-left text-md-right mb-2">
						<div v-if="caseEntity.modified" class="small text-muted">
							<span v-if="caseEntity.modified" :title="$filters.formatTimestamp(caseEntity.modified)">
								Last updated {{ $filters.fromNow(caseEntity.modified) }}
							</span>
							<span v-if="caseEntity.modified_by_user && caseEntity.modified_by_user.full_name">
								by
								<router-link
									:to="{ name: 'users.view', params: { id: caseEntity.modified_by } }"
									title="View User"
								>
									{{ caseEntity.modified_by_user.full_name }}
								</router-link>
							</span>
						</div>
					</b-col>
				</b-row> -->
		 		<!-- <b-row class="my-4">
					<b-col cols="4" xl="8" class="text-left">
						<b-button @click="showDetails = !showDetails" variant="secondary">
							<span v-if="showDetails">Hide Details</span>
							<span v-else>Case Details</span>
						</b-button>
						
						<b-button v-if="caseEntity.old_notes !== null" @click="toggleOldNotes" class="btn-orange-gradient">
							<span v-if="showOldNotes">Hide Old Notes</span>
							<span v-else>Old Notes</span>
						</b-button>

						
						<b-form-input v-if="showOldNotes" readonly :value="caseEntity.old_notes">{{ caseEntity.old_notes }}</b-form-input>
						 
						<b-button @click="showData" variant="secondary">
							<span v-if="showLoveMessage">Hide Data</span>
							<span v-else>Show Data</span>
						</b-button>
						<b-button @click="showFormattedData" variant="secondary">
							<span v-if="isFormattedData">Hide Formatted Data</span>
							<span v-else>Show Formatted Data</span>
						</b-button>
						<b-button v-b-toggle.formattedData>
							<span >Formatted Data</span>
						</b-button>
					</b-col>
				</b-row> -->
		<b-collapse v-model="isFormattedData" id="collapse1" class="mt-2">
			<b-container fluid class="bv-example-row">
				
				<template>
					<div >
						<b-table responsive striped hover :items="items"></b-table>
					</div>
				</template>
				<hr>
			    <b-row>
				<b-col>
				  <div class="info-box">
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
							<b-col cols="12">
								<div>
									<b-nav tabs>
										<b-nav-item active><h6>Patient Information</h6></b-nav-item>
									</b-nav>
								</div>
							</b-col>
						</b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Identifier Code  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">QC</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >First Name  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">Sakshi</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Middle Name  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box"></p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Last Name  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">Mittal</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Contact Number  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">(987)-654-3210</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Claim Status Code &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">2</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Total Claim Charge Amount &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">$226.00</p></b-col>
					    </b-row>

					    <b-row class="content-margin">
						    <b-col cols="6.5" >Claim Payment Amount  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">$132.00</p></b-col>
					    </b-row>
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active ><h6>Payer Identification</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin" >
						<b-col cols="6.5" >Entity Identifier  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">PR</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Payer Name  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">MEDICARE B</p></b-col>
					</b-row>
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Payer Address</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Address &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">481A00 DEER RUN ROAD</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >City &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">WEST PALM BCH</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >State  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">FL</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >ZIP &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">11114</p></b-col>
					</b-row>
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Payer Contact Information</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Contact Name &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">JOHN WAYNE</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Contact Number &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">(123)-456-7890</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Alternate Contact Number &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">(800)-555-1212</p></b-col>
					</b-row>
					
				</div>
					
				</b-col>
				

				<b-col>
				  <div class="info-box">
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Payee Identification</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Entity Identifier  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">PE</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Premium Payer Name &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">ATONEWITHHEALTH</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Intermediary Bank Identifier &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">3UR334563</p></b-col>
					</b-row>
					
					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Payee Address</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Address &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">3501 JOHNSON STREET</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >City  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">SUNSHINE</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >State &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">FL</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >ZIP  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">12345</p></b-col>
					</b-row>
					
					<b-row class="content-margin">
						<b-col cols="6.5" >Contact Number &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">(123)-456-7890</p></b-col>
					</b-row>

					
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Service Claim Information</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Policy Number  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">11861</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Total Billed Amount &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">$226.00</p></b-col>
					</b-row>
					
					<b-row class="content-margin">
						<b-col cols="6.5" >Total Adjustment Amount &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">$94.00</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Total Paid &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">$132.00</p></b-col>
					</b-row>

					<b-row style="margin-bottom: 20px;padding-right: 50px;">
							<b-col cols="12">
								<div>
									<b-nav tabs>
										<b-nav-item active><h6>Diagnosis Code</h6></b-nav-item>
									</b-nav>
								</div>
							</b-col>
						</b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" > 837P Primary DX &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >837P Secondary DX&nbsp;  &nbsp;</b-col> 
						    
					    </b-row>

				</div>
				</b-col>

				
				<b-col>
					<div class="info-box">
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Transactions</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Transaction Set Identifier &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">835</p></b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Transaction Set Control Number &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">0001</p></b-col>
					</b-row>
					<b-row style="margin-bottom: 20px;padding-right: 50px;">
						<b-col cols="12">
							<div>
								<b-nav tabs>
									<b-nav-item active><h6>Financial Information</h6></b-nav-item>
								</b-nav>
							</div>
						</b-col>
					</b-row>
					<b-row class="content-margin">
						<b-col cols="6.5" >Transaction Handling Code  &nbsp;  &nbsp;</b-col> 
						<b-col cols="5.5" ><p class="value-box">I</p></b-col>
					</b-row>
						<b-row class="content-margin">
							<b-col cols="6.5" >Total Premium Payment  &nbsp;  &nbsp;</b-col> 
							<b-col cols="5.5" ><p class="value-box">$132.00</p></b-col>
						</b-row>
						<b-row class="content-margin">
							<b-col cols="6.5" >Credit or Debit Code  &nbsp;  &nbsp;</b-col> 
							<b-col cols="5.5" ><p class="value-box">C</p></b-col>
						</b-row>
					    <b-row  class="content-margin">
						    <b-col cols="6.5" >Payment Method  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">Check</p></b-col>
					    </b-row>
						
						<b-row style="margin-bottom: 20px;padding-right: 50px;">
							<b-col cols="12">
								<div>
									<b-nav tabs>
										<b-nav-item active><h6>Reassociation Trace Number</h6></b-nav-item>
									</b-nav>
								</div>
							</b-col>
						</b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Trace Type Code  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">1</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Current Transaction Trace Number &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">0063158ABC</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Originating Company Identifier  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">1566339911</p></b-col>
					    </b-row>

					    <b-row class="content-margin">
						    <b-col cols="6.5" >Reference Identification Qualifier  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">EV</p></b-col>
					    </b-row>
					    <b-row class="content-margin">
						    <b-col cols="6.5" >Member Group or Policy Number  &nbsp;  &nbsp;</b-col> 
						    <b-col cols="5.5" ><p class="value-box">030240928</p></b-col>
					    </b-row>
						
				    </div>
				</b-col>

				</b-row>
			  </b-container>
			</b-collapse>
			<b-collapse v-model="showLoveMessage">
				<template>
					<div >
						<pre>{{ formattedData }}</pre>
					</div>
				</template>
			</b-collapse>
		
				<b-collapse v-model="showDetails">
			<b-row>
				<b-col cols="12" lg="4" class="mb-2">
					<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Case Details</h5>
					<b-card>
						<dl class="mb-0">
							<div class="row">
								<dt class="col-5 text-muted h6 small">Case ID</dt>
								<dd class="col-7">
									<span v-if="caseEntity.id" class="text-primary font-weight-bold">{{ caseEntity.id }}</span>
								</dd>
							</div>
							<div class="row">
								<dt class="col-5 text-muted h6 small">Status</dt>
								<dd class="col-7">
									<case-status-label :value="caseEntity" />
									<b-badge v-if="caseEntity.unable_to_complete" pill variant="warning"
										title="Unable To Complete">
										<font-awesome-icon icon="exclamation-triangle"
											class="mx-0 px-0" />
										UTC
									</b-badge>
								</dd>
							</div>
							<div v-if="caseEntity.patient && caseEntity.patient.full_name" class="row">
								<dt class="col-5 text-muted h6 small">Patient</dt>
								<dd class="col-7">
									<router-link
										:to="{ name: 'patients.view', params: { id: caseEntity.patient_id } }"
										title="View Patient">
										{{ caseEntity.patient.full_name }}
									</router-link>
								</dd>
							</div>
							<div v-if="caseEntity.patient && caseEntity.patient.date_of_birth" class="row">
								<dt class="col-5 text-muted h6 small">Patient DOB</dt>
								<dd class="col-7">
									<span>{{ $filters.formatDate(caseEntity.patient.date_of_birth) }}</span>
									<span v-if="caseEntity.patient.age">
										&mdash;
										{{ caseEntity.patient.age }}
									</span>
									<span v-if="caseEntity.patient.age !== 0" >yrs</span>
								</dd>
							</div>

							<div v-if="caseEntity.appeal_type && caseEntity.appeal_type.name" class="row">
								<dt class="col-5 text-muted h6 small">Case Type</dt>
								<dd class="col-7">{{ caseEntity.appeal_type.name }}</dd>
							</div>
							<div v-if="caseEntity.disciplines && caseEntity.disciplines.length > 0" class="row mb-2">
								<dt class="col-5 text-muted h6 small">Disciplines</dt>
								<dd class="col-7">
									<span v-for="(discipline, index) in caseEntity.disciplines" :key="discipline.id">
										{{ discipline.name }}<span v-if="index < caseEntity.disciplines.length - 1">, </span>
									</span>
								</dd>
							</div>
							<div v-else class="row mb-2">
								<dt class="col-5 text-muted h6 small">Disciplines</dt>
								<dd class="col-7">-</dd>
							</div>

							<div v-if="caseEntity.denial_type && caseEntity.denial_type.name" class="row">
								<dt class="col-5 text-muted h6 small">Denial Type</dt>
								<dd class="col-7">
									{{ caseEntity.denial_type.name }}
								</dd>
							</div>
							<!-- <div v-if="caseEntity.client_employee && caseEntity.client_employee.full_name"
								class="row">
								<dt class="col-5 text-muted h6 small">Primary Physician</dt>
								<dd class="col-7">
									<router-link :to="{
										name: 'clientEmployees.view',
										params: { id: caseEntity.client_employee.id },
									}" title="View Physician">
										{{ caseEntity.client_employee.full_name }}
									</router-link>
								</dd>
							</div> -->
							<div v-if="caseEntity.case_outcome && caseEntity.case_outcome.name" class="row">
								<dt class="col-5 text-muted h6 small">Outcome</dt>
								<dd class="col-7">
									{{ caseEntity.case_outcome.name }}
								</dd>
							</div>
							<div v-if="caseEntity.total_claim_amount" class="row">
								<dt class="col-5 text-muted h6 small">Total Claim Amount</dt>
								<dd class="col-7">
									{{ $filters.currency(caseEntity.total_claim_amount) }}
								</dd>
							</div>
							<div v-if="caseEntity.disputed_amount" class="row">
								<dt class="col-5 text-muted h6 small">Initial Denial Amount</dt>
								<dd class="col-7">
									{{ $filters.currency(caseEntity.disputed_amount) }}
									  <!-- ${{caseEntity.disputed_amount}} -->
								</dd>
							</div>
							<div v-if="caseEntity.settled_amount" class="row">
								<dt class="col-5 text-muted h6 small">Settled</dt>
								<dd class="col-7">
									{{ $filters.currency(caseEntity.settled_amount) }}
								</dd>
							</div>
							<div v-if="caseEntity.reimbursement_amount" class="row">
								<dt class="col-5 text-muted h6 small">Reimbursement</dt>
								<dd class="col-7">
									{{ $filters.currency(caseEntity.reimbursement_amount) }}
								</dd>
							</div>
						</dl>
					</b-card>
				</b-col>
				<b-col cols="12" lg="4" class="mb-2">
					<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Facility &amp; Visit</h5>
					<b-card>
						<!-- <dl class="mb-0">
							<div class="row">
								<dt class="col-5 text-muted h6 small">Name</dt>
								<dd class="col-7">
									<div v-if="caseEntity.facility && caseEntity.facility.name">
										<router-link :to="{
											name: 'facilities.view',
											params: { id: caseEntity.facility.id },
										}">
											{{ caseEntity.facility.name }}
											<b-badge v-if="caseEntity.facility.is_encore === 1" pill variant="info" title="Encore">
												Encore
											</b-badge>

										</router-link>
									</div>
									<div v-else class="text-muted">&mdash;</div> -->
									<dl class="mb-0">
							<div class="row">
								<dt class="col-5 text-muted h6 small">Name</dt>
								<dd class="col-7 d-flex align-items-center">
									<div v-if="caseEntity.facility && caseEntity.facility.name">
										<router-link :to="{
											name: 'facilities.view',
											params: { id: caseEntity.facility.id },
										}" class="d-flex align-items-center">
											<span>{{ caseEntity.facility.name }}</span>
											<b-badge v-if="caseEntity.facility.is_encore === 1" pill variant="info" title="Encore" class="ml-2">
												Encore
											</b-badge>
										</router-link>
									</div>
									<div v-else class="text-muted">&mdash;</div></dd>
									

									
							</div>
							<div v-if="caseEntity.facility &&
								caseEntity.facility_type &&
								caseEntity.facility.facility_type.name
								" class="row">
								<dt class="col-5 text-muted h6 small">Type</dt>
								<dd class="col-7" v-text="caseEntity.facility.facility_type.name" />
							</div>
							<div v-if="caseEntity.visit_number" class="row">
								<dt class="col-5 text-muted h6 small">Visit ID</dt>
								<dd class="col-7" v-text="caseEntity.visit_number" />
							</div>
							<div v-if="caseEntity.admit_date" class="row">
								<dt class="col-5 text-muted h6 small">Begin DOS</dt>
								<dd class="col-7">
									<p class="mb-0">
										{{ $filters.formatDate(caseEntity.admit_date) }}
									</p>
									<p class="mb-0 small text-muted">
										{{ $filters.fromNow(caseEntity.admit_date) }}
									</p>
								</dd>
							</div>
							<div v-if="caseEntity.discharge_date" class="row">
								<dt class="col-5 text-muted h6 small">End DOS</dt>
								<dd class="col-7">
									<p class="mb-0">
										{{ $filters.formatDate(caseEntity.discharge_date) }}
									</p>
									<p class="mb-0 small text-muted">
										{{ $filters.fromNow(caseEntity.discharge_date) }}
									</p>
								</dd>
							</div>
							<div v-if="caseEntity.length_of_stay" class="row">
								<dt class="col-5 text-muted h6 small">Length of Stay</dt>
								<dd class="col-7">
									{{ $filters.formatNumber(caseEntity.length_of_stay) }} day{{
										caseEntity.length_of_stay !== 1 ? "s" : ""
									}}
								</dd>
							</div>
							<div v-if="hasReadmissions" class="row">
								<dt class="col-5 text-muted h6 small">Readmissions</dt>
								<dd class="col-7">
									<b-list-group class="mb-0">
										<b-list-group-item
											v-for="readmission in caseEntity.case_readmissions"
											:key="readmission.id"
											class="d-flex justify-content-between align-items-center">
											<div class="d-flex align-items-start">
												<b-avatar variant="light" class="mr-2" size="sm">
													<font-awesome-icon icon="calendar"
														fixed-width />
												</b-avatar>
												<div>
													<div>
														<span v-if="readmission.admit_date">
															{{
																$filters.formatDate(readmission.admit_date)
															}}
														</span>
														<span v-if="readmission.admit_date && readmission.discharge_date"
															class="text-muted">&mdash;</span>
														<span v-if="readmission.discharge_date">{{
															$filters.formatDate(readmission.discharge_date)
														}}</span>
													</div>
													<div class="small text-muted">
														<span v-if="readmission.length_of_stay">{{
															readmission.length_of_stay }} day{{
		                                                readmission.length_of_stay != 1 ?
		                                                "s" : ""
	                                                    }}</span>
														<span v-if="readmission.length_of_stay && readmission.visit_number
																">&mdash;</span>
														<span v-if="readmission.visit_number">Visit
															#{{ readmission.visit_number
															}}</span>
													</div>
												</div>
											</div>
										</b-list-group-item>
									</b-list-group>
								</dd>
							</div>
						</dl>
					</b-card>
				</b-col>
				<b-col cols="12" lg="4" class="mb-2">
					<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Primary Insurance</h5>
					<b-card class="mb-4">
						<dl class="mb-0">
							<div v-if="caseEntity.insurance_provider && caseEntity.insurance_provider.name"
								class="row">
								<dt class="col-5 text-muted h6 small">Name</dt>
								<dd class="col-7">
									<router-link :to="{
										name: 'insuranceProviders.view',
										params: { id: caseEntity.insurance_provider.id },
									}">
										{{ caseEntity.insurance_provider.name }}
									</router-link>
								</dd>
							</div>
							<!-- <div class="row" v-if="caseEntity.insurance_provider_type.insurance_provider_type">
								<dt class="col-5 text-muted h6 small">Insurance Provider Type</dt>
								<dd class="col-7">
									<span
										v-if="caseEntity.insurance_provider_type.insurance_provider_type">
										{{ caseEntity.insurance_provider_type.insurance_provider_type }}
									</span>
								</dd>
							</div> -->
							<div class="row" v-if="caseEntity && caseEntity.insurance_provider_type && caseEntity.insurance_provider_type.insurance_provider_type">
								<dt class="col-5 text-muted h6 small">Insurance Provider Type</dt>
								<dd class="col-7">
									<span v-if="caseEntity.insurance_provider_type.insurance_provider_type">
										{{ caseEntity.insurance_provider_type.insurance_provider_type }}
									</span>
								</dd>
							</div>
							<div class="row" v-if="caseEntity.insurance_type && caseEntity.insurance_type.name">
								<dt class="col-5 text-muted h6 small">Audit Type</dt>
								<dd class="col-7">
									<span
										v-if="caseEntity.insurance_type && caseEntity.insurance_type.name">
										{{ caseEntity.insurance_type.name }}
									</span>
								</dd>
							</div>
							<div v-if="caseEntity.insurance_plan" class="row">
								<dt class="col-5 text-muted h6 small">Plan</dt>
								<dd class="col-7">
									{{ caseEntity.insurance_plan }}
								</dd>
							</div>
							<div v-if="caseEntity.insurance_number" class="row">
								<dt class="col-5 text-muted h6 small">Number</dt>
								<dd class="col-7">
									{{ caseEntity.insurance_number }}
								</dd>
							</div>
						</dl>
					</b-card>

					<div v-if="caseEntity.denial_reasons.length > 0" cols="12" lg="4" class="mb-2">
						<div class="d-flex justify-content-between">
							<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Denial Types</h5>
							<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Denial Reasons</h5>
						</div>

						<b-list-group>
							<b-list-group-item 
								v-for="denialReason in uniqueDenialReasons" 
								:key="denialReason.id" 
								class="py-2 d-flex justify-content-between">
								<span>{{ denialReason.denialTypeName }}</span>
								<span>{{ denialReason.denialReasonName }}</span>
							</b-list-group-item>
						</b-list-group>
					</div>
					<!-- <div v-if="caseEntity.disciplines.length > 0" cols="12" lg="4" class="mb-2">
						<h5 class="h6 my-2 font-weight-bold text-muted text-uppercase">Disciplines</h5>

						<b-list-group>
							<b-list-group-item v-for="discipline in caseEntity.disciplines" :key="discipline.id"
								class="py-2">
								<span>{{ discipline.name }}</span>
							</b-list-group-item>
						</b-list-group>
					</div> -->
				</b-col>
			</b-row>
		</b-collapse>
				<b-nav card-header tabs >
					<b-nav-item 
						title="Case Details"
						exact
						active-class="active font-weight-bold"
						link-classes="px-3"
						:to="{ name: 'cases.view', params: {id: $route.params.id,  insuranceAppealIdsObject:insuranceAppealIdsObject} }"
					>
						<case-status-label :value="caseEntity" class="mb-0" v-if="caseEntity.status != 'UTC'"/>
						<b-badge v-if="caseEntity.unable_to_complete" pill variant="warning" title="Unable To Complete">
							<font-awesome-icon icon="exclamation-triangle" class="mx-0 px-0" />
						</b-badge>
						<span >Case</span>
					</b-nav-item>

			     <!--		<b-nav-item
						v-for="caseRequest in caseEntity.case_requests"
						:key="'request_' + caseRequest.id"
						:to="{
							name: 'caseRequests.view',
							params: { id: caseEntity.id, case_request_id: caseRequest.id },
						}"
						:title="caseRequest.name ? caseRequest.name : '(Missing Name)'"
						active-class="active font-weight-bold"
					>
						<case-request-status-label icon :value="caseRequest" class="d-none d-lg-inline mr-2" />
						<span v-if="!caseRequest.type_label">Request</span>
						<span v-else>{{ caseRequest.type_label }}</span>
					</b-nav-item>

				  -->
				</b-nav>
			</b-card-header>
			<b-card-header header-tag="nav" class="mt-2">
				<b-nav card-header tabs>
					<b-nav-item
					v-for="appeal in caseEntity.appeals.slice().sort((a, b) => a.id - b.id)"
					:key="'appeal_' + appeal.id"
					:to="{ name: 'appeals.view', params: { id: caseEntity.id, appeal_id: appeal.id } }"
					:title="checkAppealName(caseEntity, appeal)"
					active-class="active font-weight-bold"
					>
					<appeal-status-label icon :value="appeal" class="d-none d-lg-inline mr-2" />
					<span v-text="checkAppealName(caseEntity, appeal)" />
					</b-nav-item>
				</b-nav>
			</b-card-header>
			<router-view
				ref="routerView"
				:key="routerKey"
				:case-entity="caseEntity"
				:value="currentAppeal"
				:appealName="checkAppealName(caseEntity, currentAppeal)"
				@added="addedAppeal"
				@deleted="deletedAppeal"
				@updated="updatedAppeal"
				@cancelled="refresh"
				@reopened="refresh"
				@added-request="addedRequest"
				@updated-request="updatedRequest"
				@deleted-request="deletedRequest"
			></router-view>
		</b-card>

		<close-case-modal
			v-if="caseEntity.id"
			id="closeCaseModal"
			title="Close Case"
			:case-entity="caseEntity"
			@closed="closedCase"
		/>
		<!-- <b-modal v-model="showModal" hide-footer>
			<template #modal-header>
				<h4>Case Stats</h4>
			</template>
			<template #modal-body>
				<DataTable :data="caseEntity.appeals">
					<template #head>
					<tr>
						<th>status</th>
					</tr>
					</template>
					 <template >
						<tr v-for="(item, index) in caseEntity.appeals" :key="index">
							<td>{{ item.appeal_status }}</td>  Assuming you have an ID in your caseEntity 
							
						</tr>
					</template> 
				</DataTable>
			</template>
			<hr>
			<div class="d-flex justify-content-between">
				<b-button @click="hidemodal">Close</b-button>
	
			</div>
    	</b-modal> -->

		<!-- Old Notes Modal -->
		<b-modal v-model="showOldNotes"  hide-footer >
			<template #modal-header>
				<h4>Case Old Notes</h4>
			</template>
			<!-- <b-form-input v-if="showOldNotes" readonly :value="caseEntity.old_notes">{{ caseEntity.old_notes }}</b-form-input> -->
			<p v-if="showOldNotes" style="word-wrap: break-word; max-width: 100%;">{{ caseEntity.old_notes }}</p>
			<div class="d-flex justify-content-center pt-3">
				<b-button @click="toggleOldNotes">Close</b-button>
			</div>
		</b-modal >

		<b-modal v-model="showCaseNotes"  hide-footer >
			<template #modal-header>
				<h4>Case Notes</h4>
			</template>
			<b-form-textarea
				v-if="showCaseNotes && !savingCaseNotes"
				v-model="caseNotes"
				style="word-wrap: break-word; max-width: 100%;"
				placeholder="No notes added"
			></b-form-textarea>
			<div class="d-flex justify-content-between pt-3" v-if="showCaseNotes && !savingCaseNotes">
				<b-button @click="saveCaseNotes" class="btn btn-outline-primary" variant="light">Save</b-button>
				<b-button @click="toggleShowCaseNotes" variant="light" class="btn btn-outline-danger">Close</b-button>
			</div>
			<div class="d-flex justify-content-center align-items-center" style="height: 100%;" v-if="savingCaseNotes">
				<h4>
					<font-awesome-icon icon="circle-notch" spin fixed-width />
				</h4>
			</div>
		</b-modal >


		<b-modal v-model="showModal"  hide-footer size="xl">
			<template #modal-header>
				<h4>Case Stats</h4>
			</template>

				<empty-result v-if="sortedAppeals.length < 1" icon="file">
					No Appeal has been created.
					<template #content>
						<p>Please create an appeal.</p>
					</template>
				</empty-result>

				<table v-else class="table table-bordered table-hover mb-0">
					<thead>
						<tr>
							<th class="col-md-1 center-both font-weight-bold align-middle text-center">Opportunity</th>
							<th class="col-md-1 center-both font-weight-bold align-middle text-center">Decision  </th>
							<th v-if="hasContract" class="col-md-1 center-both font-weight-bold align-middle text-center">Indemnification</th>
							<th class="col-md-1 center-both font-weight-bold align-middle text-center">Denial Amount ($)</th>
							<th v-if="hasContract" class="col-md-1 center-both font-weight-bold align-middle text-center">Contract Amount ($)</th>
							<th class="col-md-1 center-both font-weight-bold align-middle text-center">Amount Won ($)</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in sortedAppeals" :key="index">	
                             <td>
								<span v-text="checkAppealName(caseEntity, item)" />
							</td>
							<td class="col-md-1 center-both align-middle text-center">{{ item.appeal_decision ? item.appeal_decision : '-' }}</td>
							<td v-if="hasContract" class="col-md-1 center-both align-middle text-center"
								:title="checkIndemnificationDays(item, caseEntity) < 0
										? `${(-1) * checkIndemnificationDays(item , caseEntity)} Days`
										: checkIndemnificationDays(item, caseEntity) > 0 
										? `${checkIndemnificationDays(item , caseEntity)} Days`
										: `${checkIndemnificationDays(item, caseEntity)} is missing`">
								<span :style="{
									color: checkIndemnificationDays(item, caseEntity) === 'Audit Received Date' ||
										checkIndemnificationDays(item, caseEntity) === 'Audit Letter Date' ||
										checkIndemnificationDays(item, caseEntity) === 'Indemnification Days'
										? 'orange' // Change warning color here
										: checkIndemnificationDays(item, caseEntity) < 0
										? 'red'
										: 'green'
								}"> <b>
										{{ (checkIndemnificationDays(item, caseEntity) === 'Audit Received Date' ||
											checkIndemnificationDays(item, caseEntity) === 'Audit Letter Date' ||
											checkIndemnificationDays(item, caseEntity) === 'Indemnification Days' )
											? "Unavailable"
											: checkIndemnificationDays(item, caseEntity) < 0 
											? "Breach" 
											: "OK" }}
									</b>
								</span>
							</td>
							<td class="col-md-1  text-center">
								{{
									item 
									? (parseFloat(item.disputed_amount) === 0 
										? "0.00" 
										: (!item.pre_appeal && item.disputed_amount !== undefined && item.disputed_amount !== null
											? formatNumber(item.disputed_amount) 
											: "-")
									)
									: "-"
								}}
							</td>
							<td class="col-md-1  text-center" v-if="hasContract">
								{{ 
									item ? formatNumber(item.contract_risk_Amt_Cal) : '-' }}
							</td>
							<td class="col-md-1 text-center">
								{{ item && item.reimbursed_amount !== null
									? (["0", "0.00", ".00"].includes(item.reimbursed_amount) 
										? '0.00'
										: formatNumber(item.reimbursed_amount))
									: '-' }}
							</td>



 
						</tr>
					</tbody>
				</table>
			
			<hr>
			<h5 v-if="caseEntity.closed">
	        Case Closed <span v-if="!outcomeData.length"> - </span>
			</h5>
			<div v-if="caseEntity.closed">
				<div v-if="showLoading">
					<loading-indicator class="my-5" />
				</div>
				<div v-else>
					<div v-if="outcomeData.length">
						<div v-for="(item, index) in outcomeData" :key="index">
							{{ item.name }}
							<span v-if="item.name === 'Others' && caseEntity.case_outcome_other">
								- {{ caseEntity.case_outcome_other }}
							</span>
						</div>
					</div>
				</div>
			</div>



			<hr v-if="caseEntity.closed">
			<b-row>
				<b-col cols="3">
    <h5>Summary</h5>
    <p class="mb-2">
        <span>Total Claim Amount&nbsp; &nbsp;:&nbsp; </span>
        <span 
            v-if="caseEntity.total_claim_amount !== null && caseEntity.total_claim_amount !== undefined && !isNaN(parseFloat(caseEntity.total_claim_amount))"
            class="text-right" 
            style="float: right;">
            <strong>${{ parseFloat(caseEntity.total_claim_amount) === 0 ? "0.00" : parseFloat(caseEntity.total_claim_amount).toFixed(2) }}
            </strong>
        </span>
        <span v-else>-</span>
    </p>
    <p class="mb-2">
        <span>Initial Denial Amount :&nbsp;</span>
        <span 
            v-if="caseEntity.disputed_amount !== null && caseEntity.disputed_amount !== undefined && !isNaN(parseFloat(caseEntity.disputed_amount))" 
            class="text-right" 
            style="float: right;">
            <strong>${{ parseFloat(caseEntity.disputed_amount) === 0 ? "0.00" : parseFloat(caseEntity.disputed_amount).toFixed(2) }}
            </strong>
        </span>
        <span v-else>-</span>
    </p>
    <p class="mb-2" v-if="finalDenailAmount != null">
        <span>Final Denial Amount :</span>
        <span  
            class="text-right" 
            style="float: right;">
            <strong>${{ parseFloat(finalDenailAmount) === 0 ? "0.00" : parseFloat(finalDenailAmount).toFixed(2) }}
            </strong>
        </span>
    </p>
	<p class="mb-2">
		<span>
			Total Amount Won&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;  
			<span class="text-right" style="float: right;">
				<strong v-if="totalReimbursedAmount !== null">${{ totalReimbursedAmount.toFixed(2) }}</strong>
				
			</span>
			
		</span>
		<span v-if="totalReimbursedAmount === null">-</span>
		
    </p>

</b-col>
			</b-row>

			<hr>

			<hr v-if="showTable">
			<hr v-if="showTable">


			<b-row>
				<b-col cols="12">
					<h5 v-if="showTable">Denial Details</h5>
					<empty-result v-if="denialData.length < 1" icon="file">
						No Denials data has been added.
						<template #content>
							<p>Please add the denials data.</p>
						</template>
					</empty-result>
					<table class="table table-bordered table-striped" v-if="showTable && denialData.length >= 1">
							<thead>
								<tr>
									<th class="text-muted" style="width: 15%;">Appeal ID</th>
									<th style="width: 15%;">Appeal Level</th>
									<th style="width: 25%;">Denial Type</th>
									<th style="width: 45%;">Denial Reason</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="data in denialData" :key="data.id">
									<td class="align-middle text-muted">
										{{ data?.appeal_id || 'Not Available' }}
									</td>
									<td class="align-middle">
										{{ data.is_rebill ? (data.rebill_label || data.insurance_provider_appeal_level_label) : '' }}

									</td>
									<td class="align-middle">
										{{ data.denial_type_name || 'Not Available' }}
									</td>
									<td class="align-middle">
										{{ data.denial_reason || 'Not Available' }}
									</td>
								</tr>
							</tbody>
					</table>
				</b-col>
			</b-row>


			<div class="d-flex justify-content-between">
				<b-button
				    variant="light"
					v-if="!caseClosed"
					@click="checkAndOpenModal"
					:disabled="showLoading"
					title="Close this case when all opportunities have concluded"
					class="btn btn-outline-primary"
				>
					<font-awesome-icon icon="lock" fixed-width />
					<span>Close Case</span>
				</b-button>
				<b-button @click="hidemodal">Close</b-button>
			</div>
		</b-modal>

	</div>
</template>

<script type="text/javascript">
import AppealSummary from "@/clients/components/Appeals/Summary.vue";
import CaseAssign from "@/clients/components/Cases/Assign.vue";
import AppealStatusLabel from "@/clients/components/Appeals/StatusLabel.vue";
import CaseActivity from "@/clients/components/Cases/Activity.vue";
import CloseCaseModal from "@/clients/components/Cases/CloseCaseModal.vue";
import CaseRequestStatusLabel from "@/clients/components/CaseRequests/StatusLabel.vue";
import CaseStatusLabel from "@/clients/components/Cases/StatusLabel.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from "vuex";
import axios from "axios";
import { formatNumber } from "chart.js/helpers";

export default {
	name: "CaseView",
	components: {
		AppealStatusLabel,
		CaseActivity,
		CloseCaseModal,
		CaseRequestStatusLabel,
		CaseStatusLabel,
		AppealSummary,
		FontAwesomeIcon,
		CaseAssign,
	},
	data() {
		return {
			loading: true,
			reopening: false,
			error: false,
			showDetails: false,
			isFormattedData: false,
			showLoveMessage: false,
			showOldNotes: false,
			caseEntity: {
				id: null,
				created: null,
				modified: null,
				deleted: null,
				closed: null,
				patient_id: null,
				facility_id: null,
				denial_type_id: null,
				case_outcome_id: null,
				insurance_provider_id: null,
				insurance_provider_type: null,
				insurance_type_id: null,
				insurance_plan: null,
				insurance_number: null,
				total_claim_amount: null,
				reimbursement_amount: null,
				disputed_amount: null,
				settled_amount: null,
				visit_number: null,
				admit_date: null,
				discharge_date: null,
				closed: null,
				closed_by: null,
				assigned: null,
				assigned_to: null,
				client_employee_id: null,
				unable_to_complete: null,
				discipline_id: null,
				// Virtual fields
				can_add_appeal: null,
				// Associations
				patient: {
					id: null,
					full_name: "",
					list_name: "",
				},
				appeals: [],
				disciplines: [],
				case_requests: [],
				case_outcome_other: null,
				is_encore: null,
				case_outcome_info: '',
			},
			timer: null,
			outgoingList: null,
			appealList: null,
			name: null,
			showModal: false,
			processedItems: [],
			finalDenailAmount: null,
			outcomeData: [],
			insuranceAppealIdsObject: {},
			description: '',
			insurance_provider_name: null,
			showCaseNotes: false,
			savingCaseNotes: false,
			caseNotes: null,
			someReactiveProperty: true,
			denialData: [],
			showTable: false,
		};
	},
	computed: {
		...mapGetters({
			caseOutcomes: "caseOutcomes/all",
			loadingCaseOutcomes: "caseOutcomes/loadingAll"
		}),
		isCaseClosed() {
			return this.caseEntity.status === 'Closed';
		},
		sortedAppeals() {
			return this.caseEntity.appeals.slice().sort((a, b) => a.id - b.id);
		},
		totalReimbursedAmount() {
			if (!this.caseEntity || !Array.isArray(this.caseEntity.appeals)) {
				return 0; // Default to 0 if no appeals exist
			}

			let hasValue = false;
			let total = 0;

			for (const appeal of this.caseEntity.appeals) {
				if (appeal.reimbursed_amount === null) {
					continue; // Skip null values
				}
				
				hasValue = true; // At least one non-null value exists
				total += parseFloat(appeal.reimbursed_amount) || 0; // Convert to number safely
			}

			return hasValue ? total : null; // Return total if there's a valid number, otherwise null
		},


		routerKey() { 
			if (this.$route.params.appeal_id) {
				return "appeal_" + this.$route.params.appeal_id;
			}

			if (this.$route.params.case_request_id) {
				return "request_" + this.$route.params.case_request_id;
			}

			return "case";
		},
		currentAppeal() {
			return this.caseEntity.appeals.find((appeal) => appeal.id == this.$route.params.appeal_id);
		},
		hasAppeals() {
			if (!this.caseEntity || !this.caseEntity.appeals) {
				return false;
			}

			return this.caseEntity.appeals.length && this.caseEntity.appeals.length > 0;
		},
		appealCount() {
			if (!this.hasAppeals) {
				return 0;
			}

			return this.caseEntity.appeals.length;
		},
		showLoading() {
			if (this.caseEntity.id) {
				return false;
			}

			return this.loading;
		},
		caseClosed() {
			return this.caseEntity.closed && this.caseEntity.closed !== null;
		},
		hasContract() {
               return this.caseEntity.facility && this.caseEntity.facility.has_contract;
        },
		uniqueDenialReasons() {
			if (!this.denialData || this.denialData.length === 0) {
				return {
					denialReasonName: "-",
					denialTypeName: "-"
				};;
			}
			const seen = new Set();
			return this.denialData.filter(denial => {
				if (seen.has(denial.denial_reason)) {
					return false;
				} else {
					seen.add(denial.denial_reason);
					return true;
				}
			}).map(denial => {
				return {
					denialReasonName: denial.denial_reason,
					denialTypeName: denial.denial_type_name
				};
			});
        },
	},
	mounted() {
		this.refresh();
		this.fetchInsuranceProviderTypes();
		this.loading = true;
		this.insuranceAppealIdsObject = {};
				this.caseEntity.appeals.forEach(item => {
				// Get the insurance_appeal_id for the current item
				const insuranceAppealId = item.insurance_appeal_id;

				// Check if the insurance_appeal_id exists in the object, if not, create an empty array
				if (!this.insuranceAppealIdsObject[item.id]) {
					this.$set(this.insuranceAppealIdsObject, item.id, []); // Use $set to ensure reactivity
				}

				// Push the insurance_appeal_id into the array corresponding to the current caseEntity
				this.insuranceAppealIdsObject[item.id].push(insuranceAppealId);
			
				});
		this.loading = false;
		this.finalDenailAmt();
		
	},
	methods: {
		checkAndOpenModal() {
			const hasOpenOrInProcessAppeal = this.caseEntity.appeals.some(appeal => 
				// appeal.appeal_status === 'Open' || appeal.appeal_status === 'In Process' || appeal.appeal_status === 'Submitted' || appeal.appeal_status === 'UTC'
				appeal.appeal_status !== 'Closed'
			);

			if (hasOpenOrInProcessAppeal) {
				// If condition is met, open the modal
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "In Process appeal found",
						message: `Please close all appeal levels before closing the case.`,
					});
				});
				
			} else {
				// Optionally, handle the case where the condition is not met
				// For example, show an alert or a message
				this.$bvModal.show('closeCaseModal');
			}
		},
		closecase() {
			const hasOpenOrInProcessAppeal = this.caseEntity.appeals.some(appeal => 
				// appeal.appeal_status === 'Open' || appeal.appeal_status === 'In Process' || appeal.appeal_status === 'Submitted' || appeal.appeal_status === 'UTC'
				appeal.appeal_status !== 'Closed'
			);

			if (hasOpenOrInProcessAppeal) {
				// If condition is met, open the modal
				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						title: "In Process appeal found",
						message: `Please close all appeal levels before closing the case.`,
					});
				});
				
			} else {
				// Optionally, handle the case where the condition is not met
				// For example, show an alert or a message
				this.$bvModal.show('closeCaseModal');
				// this.showModal = false;
			}
			
		},
		/**
		 * Get Details
		 */
		async refresh() {
			try {
				this.loading = true;
				this.error = false;

				const response = await this.$store.dispatch("cases/get", {
					id: this.$route.params.id,
				});

				this.caseEntity = response;
				this.caseEntity.appeals.sort((a, b) => a.id - b.id);
			
				this.fetchAllDenialTypesAndDenialReaons();
			} catch (e) {
				this.error = e.response.data.message || "Unable to load case details";

				this.$store.dispatch("apiError", {
					error: e,
					message: "Failed getting case details",
				});
			} finally {
				this.loading = false;
			}
		},
		/**
		 * Delete
		 */
		async deleteEntity() {
			const confirmMessage = "⚠️ Are you sure you want to delete this case? This will delete all the related Appeals & Case Requests!";
			if (!confirm(confirmMessage)) {
				return false;
			}
			
			try {
				this.deleting = true;

				for (const request of this.caseEntity.case_requests) {
					const response = await this.$store.dispatch("caseRequests/delete", {
						case_id: this.caseEntity.id,
						id: request.id,
					});
                }
				
			
				for (const appeal of this.caseEntity.appeals) {
                    // const responseDeleteSubmittedDocuments = await axios.post('client/cancelSubmittedDocument', {appealId: appeal.id});
					// console.log("delete submiited response =",responseDeleteSubmittedDocuments);
					const response = await this.$store.dispatch("appeals/delete", {
						id: appeal.id,
					});
                }
				
				const response = await this.$store.dispatch("cases/delete", {
					id: this.$route.params.id,
				});

				this.$router.push({
					name: "cases",
				});

				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "primary",
						title: "Case Deleted",
						message: `Case, Appeals, Case Requests for patient ${response.data.patient.list_name} were deleted.`,
					});
				});
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Delete Failed",
					message: "Failed to delete case.",
				});
			} finally {
				this.deleting = false;
			}
		},
		/**
		 * Reopen
		 */
		async reopenCase(e) {
			const confirmMessage = "Are you sure you want to reopen this case? The case outcome will be removed.";
			if (!confirm(confirmMessage)) {
				return false;
			}

			try {
				this.reopening = true;

				const response = await this.$store.dispatch("cases/open", {
					id: this.$route.params.id,
				});

				this.caseEntity = response;

				this.refresh();
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Reopen Failed",
					message: "Failed to reopen case",
				});
			} finally {
				this.reopening = false;
			}
		},
		closedCase(caseEntity) {
			this.caseEntity = caseEntity;
		
			this.outcomeData = [];
			this.refresh();
		},
		addedAppeal(appeal) {
			this.caseEntity.appeals.push(appeal);
			this.refresh();
		},
		updatedAppeal(appeal) {
			this.refresh();
		},
		deletedAppeal(appeal) {
		
			delete this.insuranceAppealIdsObject[appeal.id];

			this.refresh();
		},
		addedRequest(request) {
			this.caseEntity.case_requests.push(request);
		},
		updatedRequest(request) {
			this.$refs.routerView.refresh();
			this.refresh();
		},
		deletedRequest(request) {
			this.refresh();
		},
		async test(){
			const url = "/client/insuranceappeal";
				
				const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});
			
				this.outgoingList = response.data;
			
			const appealListUrl = '/client/appealList';
			const appealListResponse = await axios.get(appealListUrl, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});

				this.appealList = appealListResponse.data;

			// 	const agencyListUrl = '/client/agencyList';
			// const agencyListResponse = await axios.get(agencyListUrl, {
			// 	headers: {
			// 		"Accept": "application/json",
			// 		// You can add other headers here if needed
			// 	},
			// 	});
			// 	console.log("Agency Response =", agencyListResponse);
			// 	this.agencyList = agencyListResponse.data;
				
		},
		checkAppealName(caseEntity , appeal){
			if(appeal?.is_rebill){
				return appeal.rebill_label?appeal.rebill_label:'Unknown Re-bill Level';
			}
			return appeal?.insurance_provider_appeal_level?.label ?? "Unknown Level";
		},
		showFormattedData(){
			this.isFormattedData = !this.isFormattedData;
		},
		async showData(){

			this.showLoveMessage = !this.showLoveMessage;
			const patientDetails = {
                   fullName:this.caseEntity.patient.full_name,
				   firstName:this.caseEntity.patient.first_name,
				   middleName:this.caseEntity.patient.middle_name,
				   lastName:this.caseEntity.patient.last_name,
				   admitDate:this.caseEntity.admit_date
                };

			try{
				const response = await axios.post('/client/patientParsedInfo', patientDetails);
			
				if(response.data.Loop2110==undefined){
					this.response = "DATA NOT AVAILABLE FOR THIS CASE";
				}
				else{
					this.response = response.data;
				}
			}
			catch(error){
				this.response = "DATA NOT AVAILABLE FOR THIS CASE";
			}
		},
		toggleOldNotes() {
			this.showOldNotes = !this.showOldNotes;
			
		},
		hidemodal (){
        this.showModal = false;
	  },
		//   async insuranceProvAppealLevel(){
		// 	try{
		// 			this.caseEntity.appeals.forEach((item)=>{
		// 				const response = await axios.post('/client/api/fetchInsuranceProvAppealLevelDetails', {'id':item.insurance_appeal_id});
		// 			console.log("Response1 =", response.data);
					
		// 			});
					
					
		// 		}
		// 		catch(error){
		// 			console.log("Error......", error);
		// 			return "Error occurred while fetching insurance provider appeal level details";
		// 		}
		//   },
		async insuranceProvAppealLevel() {
			try {
				this.processedItems = [];
				
				for (var item of this.caseEntity.appeals) {
					
					const response = await axios.post('/client/api/fetchInsuranceProvAppealLevelDetails', {'id': item.insurance_appeal_id});
					
					this.processedItems.push({label:response.data[0].label , level_type:response.data[0].level_type , decision_options:response.data[0].decision_options , appeal_id:this.caseEntity.appeals.id , appeal_decision:item.appeal_decision});
					
				}
			} catch (error) {
				console.error("Error:", error);
				return "Error occurred while fetching insurance provider appeal level details";
			}
		},
		caseStatsModalViewControl(){
			this.showModal = true;
		},
		finalDenailAmt(){
			var lengthFinalDenailAmt = this.caseEntity.appeals.length;
			
			this.finalDenailAmount = this.caseEntity.appeals[lengthFinalDenailAmt-1].outstanding_amount;
		},
		formatNumber(value) {
            if (!value) return '-';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
		checkIndemnificationDays(item, caseEntity) {
		// Ensure that item.letter_date and item.received_facilitydate are valid date strings
		if(item?.received_facilitydate == null){
			this.description = "Data for facility received date is not available"
			return "Audit Received Date";
		}
		if(item?.letter_date == null){
			this.description = "Data for facility letter date is not available"
			return "Audit Letter Date";
		}
		if (caseEntity?.facility?.facilities_contract?.indemnification_days == null) {
			this.description = "Data for facility indemnification days is not available"
			return "Indemnification Days";
		}
		// const letterDate = new Date(caseEntity.facility.facilities_contract.indemnification_days);
		const letterDate = new Date(item.letter_date);
		const indemnification_days = caseEntity.facility.facilities_contract.indemnification_days;
		const receivedDate = new Date(item.received_facilitydate);
		

		if (isNaN(letterDate) || isNaN(receivedDate)) {
			console.error('Invalid date(s) provided');
			return null;
		}

		const differenceInTime = receivedDate.getTime() - letterDate.getTime();
		const differenceInDays =  Math.ceil((receivedDate - letterDate) / (1000 * 60 * 60 * 24));
		const cal_indemnification_days =  indemnification_days -differenceInDays;
	

		return cal_indemnification_days;
		},

		async fetchInsuranceProviderTypes(){
			try {
            const response = await axios.get('/client/GetInsuranceProviderTypes');
            const insuranceProviderTypes = response.data;

			// Check if caseEntity and insurance_provider_type are defined
			if (this.caseEntity && this.caseEntity.insurance_provider_type) {
				// Iterate over insuranceProviderTypes to find matching item
				insuranceProviderTypes.forEach(item => {
					if (item.id === this.caseEntity.insurance_provider_type) {
					
						this.insurance_provider_name = item.insurance_provider_type;
					}
				});
			} 
            this.loading = false;
			} catch (error) {
				console.error('Error fetching denial reasons:', error);
				this.loading = false;
				this.error = true;
			}
    	},
		async toggleShowCaseNotes(){
			this.showCaseNotes = !this.showCaseNotes
			this.getCaseNotes();
		},
		// async saveCaseNotes(){
		// 	this.savingCaseNotes = true;
		// 	// const response = await this.$store.dispatch("cases/save", this.caseEntity);
		// 	const response = await axios.post('/client/saveCaseNotes', {case_id:this.caseEntity.id , case_notes:this.caseEntity.case_notes});
		// 	this.refresh();
		// 	this.savingCaseNotes = false;
		// 	this.showCaseNotes = false;
		// }
		async saveCaseNotes() {
			this.savingCaseNotes = true;

			try {
				// const response = await axios.post('/client/api/saveCaseNotes', {
				// 	case_id: this.caseEntity.id,
				// 	case_notes: this.caseNotes
				// });
				this.caseEntity.case_notes = this.caseNotes;
				
				let entity = {
						id: this.caseEntity.id,
						case_type_id: this.caseEntity.case_type_id,
						patient_id: this.caseEntity.patient_id,
						facility_id: this.caseEntity.facility_id,
						denial_type_id: this.caseEntity.denial_type_id,
						case_outcome_id: this.caseEntity.case_outcome_id,
						client_employee_id: this.caseEntity.client_employee_id,

						insurance_provider_id: this.caseEntity.insurance_provider_id,
						insurance_type_id: this.caseEntity.insurance_type_id,
						insurance_plan: this.caseEntity.insurance_plan,
						insurance_number: this.caseEntity.insurance_number,

						total_claim_amount: this.caseEntity.total_claim_amount,
						disputed_amount: this.caseEntity.disputed_amount,
						reimbursement_amount: this.caseEntity.reimbursement_amount,
						visit_number: this.caseEntity.visit_number,

						admit_date: this.caseEntity.admit_date,
						discharge_date: this.caseEntity.discharge_date,

						unable_to_complete: this.caseEntity.unable_to_complete,

						case_readmissions: this.caseEntity.case_readmissions,

						assigned_to: this.caseEntity.assigned_to,

						//Later Development
						mrt_number: this.caseEntity.mrt_number,
						insurance_provider_type: this.caseEntity.insurance_provider_type,
						insuranceRateType: this.caseEntity.insurance_type,
						contract_paid_amt_est: this.caseEntity.contract_paid_amt_est,
						case_notes: this.caseEntity.case_notes,
					};
				
				const response = await this.$store.dispatch("cases/save", entity);
			

				// Assuming response handling based on your application's needs
				this.getCaseNotes();
				// Optionally update UI states
				this.savingCaseNotes = false;
				this.showCaseNotes = false;
				this.savingCaseNotes = false;
			} catch (error) {
				// Handle errors
				console.error('Error saving case notes:', error);

				// Optionally update UI states based on error handling
				this.savingCaseNotes = false;
				// Handle error feedback to the user, e.g., show an error message
			}
		},
		async getCaseNotes(){
			this.savingCaseNotes = true;
			try {
			const responseGetNotes = await axios.post('/client/api/getCaseNotes', {
					case_id: this.caseEntity.id,
				});
			this.caseNotes = responseGetNotes.data.case_notes;
		
			}
			catch (error) {
				// Handle errors
				console.error('Error saving case notes:', error);
				this.caseNotes = 'Error getting Case Notes';
			}
			finally{
				this.savingCaseNotes = false;
			}
			
		},
		refreshAllComponents(response){
		
			this.$refs.routerView.refresh();
			
		},
		async fetchAllDenialTypesAndDenialReaons(){
			const resp = await axios.post('/client/api/getAllDenialTypeAndDenialReasonForAppealForCase', {
						'case_id':this.caseEntity.id
				});
			if(resp.data.length > 0){
				this.denialData = resp.data;
				this.showTable = true;
			}else{
				this.denialData = [];
				this.showTable = false;
			}
		},
		// denialType(item) {
		// 		if(this.denialData.length >0){console.log("inside if");
		// 			for(let i=0;i<this.denialData.length;i++){
		// 				if(this.denialData[i].appeal.id === item.id ) {
		// 					return this.denialData[i].denial_type.name;
		// 				}
		// 			}
		// 		}
		// 		return "-";
				
		// },
		// denialReason(item) {
		// 			if(this.denialData.length >0){
		// 				for(let i=0;i<this.denialData.length;i++){
		// 					if(this.denialData[i].appeal.id === item.id ) {
		// 						return this.denialData[i].denial_reason.name;
		// 					}
		// 				}
		// 			}
		// 			return "-";
		// 	},
		returnContractAmountWon(caseData , appealData){
			if(caseData?.insuranceRateType >=1 && caseData.facility?.contract_pricing_schedules[caseData.insuranceRateType-1]?.insurance_type_id && appealData?.reimbursed_amount){
				return ((caseData.facility.contract_pricing_schedules[caseData.insuranceRateType - 1].contract_rate / 100) * appealData.reimbursed_amount).toFixed(2);
			}
			else{
				return '-';
			}
		}
	},
	destroyed() {
		clearInterval(this.timer);
	},
	watch: {
		caseEntity: {
			immediate: false,
			handler(val) {
				
				this.insuranceProvAppealLevel();
			
				this.$forceUpdate();
		
			},
		},
		caseOutcomes: {
			immediate: false,
			handler(val) {
				
				this.insuranceProvAppealLevel();
				
				const caseOutcomeInfo = this.caseEntity.case_outcome_info;
				// const numbers = this.caseEntity.case_outcome_info.match(/\d+/g).map(Number);
				const numbers = caseOutcomeInfo ? caseOutcomeInfo.match(/\d+/g).map(Number) : [];
				// this.outcomeData = this.caseOutcomes;
				numbers.forEach((item , index) => {
					
					this.caseOutcomes.forEach((outcome , ind) => {
					
						if (item === outcome.id) {
							
							this.outcomeData.push(outcome);
						}
					});
				});
				
			},
		},
		'caseEntity.case_outcome_info': {
			immediate: false,
			handler(val) {
				
				this.insuranceProvAppealLevel();
				
				const numbers = this.caseEntity.case_outcome_info.match(/\d+/g).map(Number);
				// this.outcomeData = this.caseOutcomes;
				numbers.forEach((item , index) => {
					
					this.caseOutcomes.forEach((outcome , ind) => {
					
						if (item === outcome.id) {
							
							this.outcomeData.push(outcome);
						}
					});
				});
			
			},
		},
	},
};
</script>
<style scoped>
.btn-orange-gradient {
    background: linear-gradient(to right, #ff8c00, #ffa500);
    color: white;
}
.nav-tabs .nav-item .active {
  background-color: #e8e8e9;
  border-bottom: 2px solid #4747ff; 
  color: #050505;
  font-weight: bold;
}
</style>